<template>
  <div>
    <Alert v-if="isFaulty" :type="'danger'" :icon="'far fa-times-circle'">
      <p class="text-center text-3xl">
        <b>
          <p>
            Whoops, looks like something went wrong, please email
            <a href="mailto:support@trainingport.net">TrainingPort.net support</a>.
          </p>
        </b>
      </p>
    </Alert>

    <Alert v-if="isLocked" spin :icon="'fa-thin fa-spinner-third'" :type="'info'">
      <span class="text-3xl">Recording score please wait.</span>
    </Alert>

    <div v-if="lesson" class="card px-10">
      <div class="flex">
        <div class="pr-10">
          <h3 class="mt-5">Scheduled Topics</h3>

          <h4 class="mt-5">{{ lesson.topic }}</h4>

          <p>{{ lesson.lesson }} - {{ lesson.sequence }} of {{ lesson.count }}</p>

          <p class="text-yellow-500">
            You may suspend this lesson if you are not able to access your aircraft.
          </p>

          <p class="text-yellow-500">
            Suspending this lesson will allow you to continue training on the next scheduled lesson, if available.
          </p>
        </div>
        <div class="flex flex-col justify-center ml-auto">
          <button class="w-full btn btn-info btn-fill" @click="launch">Begin Training</button>
          <button class="w-full mt-8 btn btn-warning btn-fill" @click="suspend">Suspend</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import REGISTRATION from "@/consts/registration";
import Alert from "@components/UIComponents/Alert";

export default {
  components: { Alert },
  props: {
    index: { type: Number, default: 0 },
    propLesson: { type: Object, default: () => { } }
  },
  emits: ["launch-training", "suspend-training"],
  data() {
    return {
      lesson: this.propLesson,
      isFaulty: false,
      isLocked: false,
    };
  },
  computed: {
    linkTitle() {
      if (this.lesson.is_suspendable) {
        return "Resume Suspended Lesson";
      }
      return "Begin Training";
    }
  },
  created() { },
  mounted() {
    let lesson = this.lesson;
    lesson.isFaulty = false;
    lesson.isLocked = false;

    lesson = this.resolveRegistrationStatus(lesson);

    this.isFaulty = lesson.isFaulty;
    this.isLocked = lesson.isLocked;

    if (this.isFaulty || this.isLocked) {
      this.lesson = null;
      return;
    }
  },
  methods: {
    launch() {
      this.$emit("launch-training", this.lesson);
    },
    suspend() {
      this.$emit("suspend-training", this.lesson);
    },
    resolveRegistrationStatus(lesson) {
      lesson = this.isRegistrationFaulty(lesson);

      if (lesson.isFaulty) {
        return lesson;
      }

      lesson = this.isRegistrationLocked(lesson);

      if (lesson.isLocked) {
        const seconds = 30;
        const time = seconds * 1000;
        setInterval(function () {
          location.reload();
        }, time);
      }

      return lesson;
    },
    isRegistrationFaulty(lesson) {
      const registration = lesson.registration;

      if (!registration) {
        lesson.isFaulty = true;
        return lesson;
      }

      if (registration.status === REGISTRATION.ERROR) {
        lesson.isFaulty = true;
        return lesson;
      }

      return lesson;
    },
    isRegistrationLocked(lesson) {
      const registration = lesson.registration;

      if (!registration) {
        lesson.isFaulty = true;
        return lesson;
      }

      if (registration.status === REGISTRATION.LOCKED) {
        lesson.isLocked = true;
        return lesson;
      }

      lesson.isLocked = false;
      return lesson;
    }
  }
};
</script>

<style lang="scss"></style>
